import type { DynamicListItem, HTMLDynamicListElement } from "@modules/_components/HTMLDynamicListElement"

export type AdvertTagData = DynamicListItem & {
    tagId: string
    tagName: string
    inactiveTagClass: string
}

const parser = new DOMParser()

export const tagPopupTemplate: HTMLElement | null = parser.parseFromString(
    `
    <div id="tag-assign-context-menu" class="hidden">
        <div class="new-tag-button-container">
            <div id="merkzettel-new-tag-trigger">
                <span class="icon dark inline before-text icon-16">
                    <svg viewBox="0 0 20 20">
                        <path d="M8.75 0h1.25v8.75h8.75v1.25h-8.75v8.75h-1.25v-8.75h-8.75v-1.25h8.75z"></path>
                    </svg>
                </span> Neues Tag anlegen
            </div>
        </div>
        <form class="context-menu-new-tag-form">
            <input type="text" class="context-menu-new-tag-input ui-input-text ui-body-a" maxlength="20" />
            <div class="tag-exist-text hidden">Dieser Name ist bereits vergeben, bitte wähle einen anderen.</div>
            <button id="merkzettel-new-tag-save" class="btn btn-ladies-primary context-menu-new-tag-save">Speichern</button>
            <div id="context-menu-new-tag-form-close">Abbrechen</div>
        </form>
    </div>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null

export const dropdownTagsListTemplate: HTMLDynamicListElement<AdvertTagData> | null = parser.parseFromString(
    `
    <dynamic-list list-container-type="div" container-class="tag-assign-tags-box">
        <template>
            <div class="auftrag-tag" data-tag-id="{tagId}" data-tag="{tagName}">
                <span class="auftrag-tag-label">{tagName}</span>
                <span class="icon dark inline lower icon-16 {inactiveTagClass}">
                    <svg viewBox="0 0 20 20">
                        <path d="M1.008 8.827l6.633 5.608 11.272-10.976 1.087 1.118-12.286 11.964-7.714-6.523z"></path>
                    </svg>
                </span>
            </div>
        </template>
    </dynamic-list>
`,
    "text/html",
).body.firstElementChild as HTMLDynamicListElement<AdvertTagData> | null

export const advertTagsListTemplate: HTMLDynamicListElement<AdvertTagData> | null = parser.parseFromString(
    `
    <dynamic-list list-container-type="div" container-class="contacts-info-tags">
        <template>
            <span class="selected-tag" data-tag-id="{tagId}" data-tag="{tagName}">
                ${SiteInfo.isMobileVersion ? `<img class="tag-icon" src="https://static.ladies-cdn.de/shared/ladies/img/icons/bookmark-tag.svg" alt="Merkzettel-Tag" />` : ""}
                {tagName}
            </span>
        </template>
    </dynamic-list>
`,
    "text/html",
).body.firstElementChild as HTMLDynamicListElement<AdvertTagData> | null
